import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';

 interface table {
  name: string;
  gender: string;
  action: string;
}

@Component({
  selector: 'app-title-modal',
  templateUrl: './title-modal.component.html',
  styleUrls: ['./title-modal.component.scss']
})
export class TitleModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  titles = null;
  data = null;
  mode = null
  Success = null
  fetch: any = [];
  filterddata: any = [];
  private _searchText:string ;

  get searchText(): string {
      return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterddata = this.filterdata(value)
}

filterdata(searchString: string) {
    return this.fetch.filter( log =>
      log.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
}

  titleForm = new FormGroup({
    name: new FormControl('', Validators.required),
    gender: new FormControl('', Validators.required),
    id: new FormControl('', Validators.required),
  });


  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      name,
      gender,
    } = this.titleForm.value;
    this.auth
      .postTitle(
        name,
        gender,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });           
          }
          else {
            this.Errors = "Not successful, please try again"
            console.log(resSuccess)
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }
  onEdit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      name,
      gender,
      id,
    } = this.titleForm.value;
    this.auth
      .editTitle(
        name,
        gender,
        id,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });          }
          else {
            this.Errors = "Not successful, please try again"
            console.log(resSuccess)
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }

  

  ngOnInit(): void {

    this.auth
      .getTitle()
      .subscribe(
        (resSuccess) => {

          this.fetch = resSuccess
          this.filterddata = this.fetch
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );
  }

  addNew() {
    this.mode = "add"
  }
  edit(title) {
    this.mode = "edit"
    this.titleForm.patchValue({
      name: title.name,
      gender: title.gender ,
      id: title.id ,
    });
    console.log(this.titleForm.value)
  }
  delete(title) {
    this.auth
      .delSet("/api/titles/deleteTitle", title.id)
      .subscribe(
        (resSuccess) => {
          this.filterddata = this.filterddata.filter(dattum => dattum.id !== title.id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }
  closeModal() {
    this.modal.closeModal();
  }

}
